export enum TokenStorageKey {
  Passwordless = "q4-passwordless-collection",
  Admin = "q4-admin",
}

export enum SessionStorageKey {
  Passwordless = "q4-passwordless",
}
